<template>
    <div class="ditch-box">
        <ditchlist @getChild="setFather" @bindBrother="bindBus" :searchData="searchData" :searchTitle="searchTitle" :searchUrl="searchUrl" :isAjax="isAjax" v-show="isShowList" :busName="'bindDitchUpdate'" :refresh="refresh"></ditchlist>
        <ditch @getChild="setFather" :searchUrl="searchUrl" :popu="popu" :isId="isId"  v-show="!isShowList" :busName="'bindDitchUpdate'"></ditch>
    </div>
</template>
<script>
    import ditch from "./ditch"
    import ditchlist from "./ditchlist"

    export default {
        name:"ditch-box",
        props:['init'],
        data(){
            return {
                isShowList:true,
                searchData:[{name:"渠道组名称",value:""},{name:"渠道组标识",value:""}],
                searchTitle:[{name:"渠道组类型"},{name:"渠道组名称"},{name:"渠道组权限"},{name:"渠道组标识"},{name:"渠道组匹配标识"}],
                searchUrl:"http://api.wildog.cn/group/",
                refresh:false,
                popu:"",
                isAjax:false,
                isEdit:false,
                isId:0,
            }
        },
        mounted(){
        },
        watch:{
            "init":function(val){
                if(val == '10'){
                    this.refresh = !this.refresh;
                }
                this.isShowList=true;
            }
        },
        methods:{
            setFather(val){
                if(!val){
                    if(!sessionStorage.getItem("ditchType")){
                        $.ajax({
                            url:this.searchUrl+"getEditInfo",
                            headers: {
                                'Auth-Token' : localStorage.getItem("token")
                            },
                            type:"POST",
                            data:{id:1},
                            dataType:"JSON",
                            success:(res)=>{
                                let data = res.data;
                                this.popu = data.group_type;
                                sessionStorage.setItem("ditchType",JSON.stringify(data.group_type))
                            }
                        })
                    }else{
                        this.popu = JSON.parse(sessionStorage.getItem("ditchType"))
                    }
                }
                if(val == 2){
                    this.isAjax = !this.isAjax
                }
                // val存在是新增页跳列表页
                if(val){
                    this.isShowList = true;
                }else{
                    this.isShowList = false;
                }
            },
            // bindBus编辑跳转
            bindBus(val){
                this.isId = val?val:0;
            }
        },
        components:{
            ditch:ditch,
            ditchlist:ditchlist
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/ditchsbox.vue